
import React,{useEffect,useState}  from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { CoverPage } from './Pages/CoverPage';
import { sampleLearnerData } from './Data/reportData';
import { PageSeparator } from './PageSeparatorUI';
import { PerformancePage } from './Pages/PerformancePage';
import { ChecklistPage } from './Pages/ChecklistPage';
import { TakeawaysPage } from './Pages/TakeawaysPage';
import { checklistData } from './Data/checklistData';
import { takeawaysData } from './Data/takeawaysData';
import { PDFDownloadButton } from './Report/PDFDownloadButton';
import { useColor } from "../../../../../components/ui/ColorContext";
import './Learner.css';
import { Buttons } from "../../../../../components/ui/button";
import { useParams } from "react-router-dom";
import { gamereport } from "utils/game/gameService";
import { generateReportHTML } from "./generateReportHTML";

const checklistEntries = Object.entries(checklistData);

const takeawayEntries = Object.entries(takeawaysData) as [
  string,
  typeof takeawaysData[string]
][];


// ✅ PROPS TYPE
interface LearnerMainFileProps {
  reportData: any;
  loading?: boolean;
  error?: any;
  learnerPlayList?:any;
   setLearnerPlayingDetails:any;
     currentScreenId:any;
       setCurrentScreenId:any;
       setReportData:any;
       setLoading:any;
       setError:any;
       setHtmlString:any;
       htmlString:any;
}

const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return "0, 255, 187"; // fallback to default green
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};
const NavigationArrow: React.FC<{
    direction: "left" | "right";
    onClick: () => void;
  }> = ({ direction, onClick }) => {
    const { primaryColor } = useColor();
    return (
      <Buttons
        variant="ghost"
        size="sm"
        onClick={onClick}
        className="w-[3.75rem] h-10 py-2 px-4 rounded-3xl transition-all duration-200 hover:scale-110"
        style={{
          background: `linear-gradient(${
            direction === "left" ? "275.041deg" : "90deg"
          },
                rgba(${hexToRgb(primaryColor)}, 0.6) 7.25%, rgba(${hexToRgb(
            primaryColor
          )}, 0.15) 84.803%)`,
          border: `1px solid ${primaryColor}`,
          boxShadow: `0px 0px 15.9542px 0px rgba(${hexToRgb(
            primaryColor
          )}, 0.3)`,
        }}
      >
        {direction === "left" ? (
          <ChevronLeft className="!w-4 !h-4 text-white" />
        ) : (
          <ChevronRight className="!w-4 !h-4 text-white" />
        )}
      </Buttons>
    );
  };
const LearnerMainFile: React.FC<LearnerMainFileProps> = ({
  reportData,
  setReportData,
  loading,
  setLoading,
  error,
  setError,
  learnerPlayList,
  setLearnerPlayingDetails,
    currentScreenId,
    setCurrentScreenId,
    htmlString,
    setHtmlString
}) => {

 const { learner_game_play_id } = useParams();

  // const [htmlString, setHtmlString] = useState<string>("");

  
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
    const isPDF = params.get("pdf") === "true";
      const learnerId = learnerPlayList?.playerId;
  const token = params.get("token");

  if (token) {
    localStorage.setItem("user", JSON.stringify({ token }));

    // Remove token from URL
    params.delete("token");

    const newUrl =
      window.location.pathname +
      (params.toString() ? "?" + params.toString() : "");

    window.history.replaceState({}, "", newUrl);

    // Reload once
    window.location.reload();
  }
}, []);



const handleNavigation = (direction: "left" | "right") => {
  if (direction === "left") {
    // Go to Previous Screen
    // setCurrentScreenId(21);
     setCurrentScreenId(22);
  }

  if (direction === "right") {
    // Go to Next Screen
    setCurrentScreenId(5);
  }
};


 const params = new URLSearchParams(window.location.search);
  const isPDF = params.get("pdf") === "true";

  const learnerId = isPDF
    ? params.get("learnerId")
    : learnerPlayList?.playerId;

 if (!learnerId) {
    return <div>Loading report...</div>;
  }
  if (loading) return <div>Loading Report...</div>;
  if (error) return <div>Error loading report</div>;

  
  if (!reportData) return <div>No report data</div>;

  const checklistEntries = Object.entries(checklistData);
  const takeawayEntries  = Object.entries(takeawaysData) as [string, typeof takeawaysData[string]][];


  return (
    <div className="lovable-theme min-h-screen bg-background overflow-y-auto">
      {!isPDF && (
        <PDFDownloadButton
          learnerId={learnerId}
          gamePlayId={learner_game_play_id}
          reportData={reportData}
          htmlString={htmlString}          // ✅ full HTML string for Puppeteer
          fileName={`ECHO-Report-${reportData.lenUsername?.replace(" ", "-")}`}
        />
      )}

     
      <div id="report-container" className="flex flex-col">

        {/* Page 1 */}
        <div data-page="1">
          <CoverPage
            learnerName={reportData.lenUsername}
            reportData={reportData}
          />
        </div>

        <PageSeparator />

        {/* Page 2 */}
        <div data-page="2">
          <PerformancePage
            data={sampleLearnerData}
            reportData={reportData}
          />
        </div>

        <PageSeparator />

        {/* Page 3 */}
        <div data-page="3">
          <ChecklistPage
           checklists={checklistEntries} 
          reportData={reportData}/>
        </div>

        <PageSeparator />

        {/* Page 4 */}
        <div data-page="4">
          <TakeawaysPage
            takeaways={takeawayEntries}
            pageNumber={1}
            reportData={reportData}
          />
        </div>

        <PageSeparator />

        {/* Page 5 */}
        <div data-page="5">
          <TakeawaysPage
            takeaways={takeawayEntries}
            pageNumber={2}
            reportData={reportData}
          />
        </div>

      </div>
      {/* Center Left & Right Navigation */}
{!isPDF && (
  <div className="fixed inset-y-0 left-0 right-0 flex items-center justify-between px-4 pointer-events-none z-50">

    {/* Left Arrow */}
    <div className="pointer-events-auto">
      <NavigationArrow
        direction="left"
        onClick={() => handleNavigation("left")}
      />
    </div>

    {/* Right Arrow */}
    <div className="pointer-events-auto">
      <NavigationArrow
        direction="right"
        onClick={() => handleNavigation("right")}
      />
    </div>

  </div>
)}
    </div>
  );
};

export default LearnerMainFile;

